// extracted by mini-css-extract-plugin
export default {"price":"B9-z","onSale":"C9-z","msrpLabelPrice":"D9-z","msrpLabel":"E9-z","originalPrice":"F9-z","percentOff":"G9-z"};